import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiUrl } from '../../utils';
import { Invoice, Payment } from '../types';

export type GetInvoicesResponse = {
  invoices: {
    invoice: Invoice,
    payments: Payment[],
  }[]
}

const baseUrl = getApiUrl('api/invoices')

// Define a service using a base URL and expected endpoints
export const invoices = createApi({
  reducerPath: 'invoicesApi',
  tagTypes: ['Invoices', 'GetInvoices'],
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      headers.set('x-api-key', process.env.REACT_APP_X_API_KEY)
      // headers.set('Content-Type', 'application/json')

      return headers
    },
    credentials: 'include',
    mode: 'cors'
  }),
  endpoints: ({ query, mutation }) => ({
    getInvoice: query<GetInvoicesResponse, string>({
      query: (projectId) => {
        return `/${projectId}`
      },
      providesTags: ['Invoices'],
    }),
    createInvoice: mutation<Invoice, Omit<Invoice, 'id' | 'invoice_number'>>({
      query: (newInvoice) => {
        return {
          url: `${newInvoice.project_id}`,
          method: 'POST',
          body: {
            invoiced_date: newInvoice.invoiced_date,
            invoice_amount: newInvoice.invoice_amount,
          }
        }
      },
      invalidatesTags: ['Invoices']
    }),
    createMultipleInvoices: mutation<Invoice, { project_id: number, invoices: { invoiced_date: number; invoice_amount: number }[] }>({
      query: (newInvoices) => {
        return {
          url: `${newInvoices.project_id}/create_multiple`,
          method: 'POST',
          body: {
            invoices: newInvoices.invoices
          }
        }
      },
      invalidatesTags: ['Invoices']
    }),
    cancelInvoice: mutation<Invoice, number>({
      query: (invoiceId) => {
        return {
          url: `/${invoiceId}/cancel_invoice`,
          method: 'PATCH'
        }
      },
      invalidatesTags: ['Invoices']
    })
    // updateInvoice: mutation<Invoice, Partial<Invoice>>({
    //   query: (updatedInvoice) => ({
    //     url: `${updatedProject.id}`,
    //     method: 'PATCH',
    //     body: updatedProject,
    //   }),
    //   invalidatesTags: ['Projects']
    // }),
  }),
  keepUnusedDataFor: 0
})

// TODO: https://stackoverflow.com/questions/61704805/getting-an-error-a-non-serializable-value-was-detected-in-the-state-when-using
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateInvoiceMutation,
  useCreateMultipleInvoicesMutation,
  useGetInvoiceQuery,
  useLazyGetInvoiceQuery,
  useCancelInvoiceMutation
} = invoices
export const invoicesApi = invoices.endpoints
export const resetInvoicesApi = () => {
  return invoices.util.resetApiState()
}